import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils'
import {ApplicationActionTypes, ServerActionTypes, SessionActionTypes} from '../ActionTypes';
import Dispatcher from '../Dispatcher';
import Session from '../record/SessionRecord';
import ApplicationRecord from '../record/ApplicationRecord';
import log from '../../script/utils/logging';


const TAG = 'ApplicationStore';


const STATE_SESSION_KEY = 'session';
const STATE_APPLICATION_KEY = 'application';
const STATE_SCHEDULED_KEY = 'scheduled';


class ApplicationStore extends ReduceStore {
    constructor() {
        super(Dispatcher);
    }


    getInitialState() {

        let initialState = {
            session: new Session({valid: false}),
            application: new ApplicationRecord(),
            scheduled: [],
        };

        return Immutable.OrderedMap(initialState);
    }

    reduce(state, action) {
        switch (action.type) {
            case SessionActionTypes.CREATE_SESSION:
                log.debug(TAG, "ApplicationStore :: CREATE_SESSION");

                if (!action.store) {
                    log.debug(TAG, "ApplicationStore :: no session????");
                    log.error(TAG, "Failure to create session, missing session info")
                    return state;
                }


                let newSession = this.cloneObject(action.session);
                newSession.valid = true;
                newSession.createdAt = Date.now();

                return state.set(STATE_SESSION_KEY, new Session(newSession));


            /**
             * Marks the current session has invalid and remove login information
             */
            case SessionActionTypes.CLOSE_SESSION: {
                log.debug(TAG, "ApplicationStore :: CLOSE_SESSION");


                const sessionRecord = state.get(STATE_SESSION_KEY);


                // If no session, no need to close again
                if (!sessionRecord.valid) {
                    return state;
                }


                let newSession = this.cloneObject(sessionRecord);
                newSession.valid = false;
                newSession.login = undefined;

                return state.set(STATE_SESSION_KEY, new Session(newSession));
            }

            case ApplicationActionTypes.CLEAR_ORDER_SELECTED: {
                log.debug(TAG, "ApplicationStore :: CLEAR_ORDER_SELECTED");

                const record = state.get(STATE_APPLICATION_KEY);


                // If no record no update
                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let selectedOrder = record.order.selected;
                if (action.orderId  &&  ( !selectedOrder || selectedOrder.id !== action.orderId) ){
                    return state;
                }


                let newRecord = this.cloneObject(record);

                newRecord.order.selected = null;

                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));

            }

            case ApplicationActionTypes.UPDATE_ORDER_SELECTED: {
                log.debug(TAG, "ApplicationStore :: UPDATE_ORDER_SELECTED");


                const record = state.get(STATE_APPLICATION_KEY);


                // If no record no update
                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let newRecord = this.cloneObject(record);

                newRecord.order.selected = null;
                if (action.order && action.order.id) {
                    newRecord.order.selected = action.order;
                }

                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));
            }


            case ApplicationActionTypes.UPDATE_DRIVER_HIGHLIGHTED: {
                log.debug(TAG, "ApplicationStore :: UPDATE_DRIVER_HIGHLIGHTED");


                const record = state.get(STATE_APPLICATION_KEY);


                // If no record no update
                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let newRecord = this.cloneObject(record);

                newRecord.driver.highlighted = null;
                if (action.driver && action.driver.id) {
                    newRecord.driver.highlighted = action.driver;
                }

                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));
            }


            case ApplicationActionTypes.ACTION_SCHEDULED_FASTFORWARD: {
                log.debug(TAG, "ApplicationStore :: ACTION_SCHEDULED_CONFIRMATION");


                const record = state.get(STATE_APPLICATION_KEY);


                // If no record no update
                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let newRecord = this.cloneObject(record);

                const scheduledArray = (Array.isArray(action.scheduled) ? action.scheduled : [action.scheduled]);

                const scheduledIds = scheduledArray.map(value => value.id);

                newRecord.scheduled.action.confirmation = scheduledArray;
                newRecord.scheduled.highlighted = scheduledIds;

                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));
            }


            case ApplicationActionTypes.ACTION_SCHEDULED_CONFIRMATION: {
                log.debug(TAG, "ApplicationStore :: ACTION_SCHEDULED_CONFIRMATION");


                const record = state.get(STATE_APPLICATION_KEY);


                // If no record no update

                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let newRecord = this.cloneObject(record);

                const scheduledArray = (Array.isArray(action.scheduled) ? action.scheduled : [action.scheduled]);

                newRecord.scheduled.highlighted = [];
                newRecord.scheduled.action.confirmation = [];
                newRecord.scheduled.action.pending = scheduledArray;


                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));
            }


            case ServerActionTypes.UPDATE_SCHEDULED_ORDERS: {
                log.debug(TAG, "ApplicationStore :: UPDATE_SCHEDULED_ORDERS");


                const record = state.get(STATE_APPLICATION_KEY);


                // If no record no update
                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let newRecord = this.cloneObject(record);


                newRecord.scheduled.action.pending = [];
                newRecord.scheduled.status.dispatched = [];

                if (Array.isArray(action.data)) {

                    action.data.forEach(order => {
                        console.log(`Order: ${order.id} -> ${order.status}` );
                        if (order.dispatchStatus === "dispatched") newRecord.scheduled.status.dispatched.push(order.id);
                    });
                }

                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));
            }


            case ServerActionTypes.UPDATE_SERVER_DATA: {
                log.debug(TAG, "ApplicationStore :: UPDATE_SERVER_DATA");


                const record = state.get(STATE_APPLICATION_KEY);

                // If no record no update
                if (record === undefined || record === null) {
                    log.error(TAG, 'store application data not found');
                    return state;
                }


                let newRecord = this.cloneObject(record);

                const store = action.data;

                // Clear selected order if not found in the store open orders
                if (newRecord.order && newRecord.order.selected !== null && newRecord.order.selected !== undefined){
                    const selectedOrder = newRecord.order.selected;
                    let selectedInOrders = false;

                    // Looking for the selected order in the open orders list
                    if (store && store.orders && store.orders.length > 0){
                        for (let i = 0; i < store.orders.length; ++i){
                            const o = store.orders[i];
                            if (o.id === selectedOrder || o.id === selectedOrder.id) {
                                selectedInOrders = true;
                                break;
                            }
                        }
                    }

                    if (!selectedInOrders){
                        newRecord.order.selected = null;
                    }
                }

                newRecord.scheduled.status.dispatched = [];


                return state.set(STATE_APPLICATION_KEY, new ApplicationRecord(newRecord));
            }


            default:
                log.debug(TAG, "ApplicationStore :: Unknown Operation => " + action.type);
                return state;
        }
    }


    cloneObject(object) {
        let tmp = JSON.parse(JSON.stringify(object));
        return tmp;
    }

}


export default new ApplicationStore();



// WEBPACK FOOTER //
// ./src/data/store/ApplicationStore.js